<!-- eslint-disable max-len -->
<template>
  <div>
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              PRODUCT CARDS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content col-8">
            <b-card-group deck>
              <b-card align="center">
                <b-img-lazy v-bind="imgConfig"
                            class="card-img card-img-top"
                />
                <h1>Kariyer İmaj</h1>
                <p class="card-text">
                  This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.
                </p>
                <div slot="footer"
                     class="with-button"
                >
                  <div class="text-left rights">
                    <div>
                      <p class="liquid d-inline-block">
                        Kalan Kullanım:
                      </p>
                      <p class="d-inline-block">
                        <b>2</b>
                      </p>
                    </div>
                    <div>
                      <p class="liquid d-inline-block">
                        Tanımlanan:
                      </p>
                      <p class="d-inline-block">
                        <b>2</b>
                      </p>
                    </div>
                  </div>
                  <div class="actions">
                    <button class="btn md bg-purple text-white">
                      KULLAN
                    </button>
                  </div>
                </div>
              </b-card>
              <b-card align="center">
                <b-img-lazy v-bind="imgConfig"
                            class="card-img card-img-top"
                />
                <h1>Kariyer İmaj</h1>
                <p class="card-text">
                  This card has supporting text below as a natural lead-in to additional content.
                </p>
                <div slot="footer"
                     class="w-100"
                >
                  <div>
                    <p class="liquid d-inline-block">
                      Kalan Kullanım:
                    </p>
                    <p class="d-inline-block">
                      <b>2</b>
                    </p>
                  </div>
                  <div>
                    <p class="liquid d-inline-block">
                      Tanımlanan:
                    </p>
                    <p class="d-inline-block">
                      <b>2</b>
                    </p>
                  </div>
                </div>
              </b-card>
              <b-card align="center">
                <b-img-lazy v-bind="imgConfig"
                            class="card-img card-img-top"
                />
                <h1>Kariyer İmaj</h1>
                <p class="card-text">
                  This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.
                </p>
                <div slot="footer"
                     class="w-100"
                >
                  <h2 class="liquid">
                    Sınırsız
                  </h2>
                </div>
              </b-card>
            </b-card-group>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              LABEL CARDS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content col-8">
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item>
                  <div class="text-color-warm-grey">
                    Şirket Adı
                  </div>
                  <h2 class="bold">
                    Kariyer.net
                  </h2>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="8">
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Üyelik Tipi
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          Sınırsız Üye
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Vergi Dairesi
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          Beşiktaş
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Vergi Numarası
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          43223221
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Fatura Adresi
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          Saray Mahallesi, Site Yolu Sokak Anel Plaza
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="4"
                           class="text-right"
                    >
                      <button class="btn md with-icon border-traid bg-white text-color-purple">
                        <i class="icon-edit" />Düzenle
                      </button>
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="8">
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Üyelik Tarihi Başlangıcı
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          1 Ocak 2018, Çarşamba
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Son Yenileme Tarihi
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          1 Ocak 2018, Çarşamba
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="4">
                          Üyelik Bitiş Tarihi
                        </b-col>
                        <b-col cols="8"
                               class="bold"
                        >
                          1 Ocak 2018, Çarşamba
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="4"
                           class="text-right"
                    >
                      <button class="btn md with-icon border-traid bg-white text-color-purple">
                        <i class="icon-edit" />Düzenle
                      </button>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              CİRCLE CARDS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content col-8">
            <b-card>
              <b-row align-v="center">
                <b-col cols="12">
                  <div class="d-inline-block mr-4">
                    <span class="rounded-circle p-4 text-color-white bg-color-dusk bold xxl">MH</span>
                  </div>
                  <div class="d-inline-block align-middle">
                    <h2>Müşteri Hizmetleri</h2>
                    <div class="lg text-color-dusk-40">
                      0216 468 76 00
                    </div>
                    <div class="lg text-color-dusk-40">
                      ahdursun@hotmail.com
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              LOGO CARDS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content col-8">
            <b-row>
              <b-col cols="4"
                     class="pb-3"
              >
                <b-card no-body>
                  <div class="height-40 pt-2 pr-2 pl-2 pb-2 d-flex align-items-center justify-content-between">
                    <i class="xl text-color-dark-mint icon-checkbox-selected" />
                  </div>
                  <div>
                    <b-img-lazy src="http://cdn1.kariyer.net/UploadFiles/Clients/Logolar/154462_110078.jpg"
                                center
                                alt="img"
                                blank-color="#bbb"
                    />
                  </div>
                  <div class="text-center pt-4 pb-3">
                    <span class="xxs text-color-warm-grey bold">YÜKLEME TARİHİ: 21 EKİM 2017</span>
                  </div>
                </b-card>
              </b-col>
              <b-col cols="4">
                <b-card no-body>
                  <div class="height-40 pt-2 pr-2 pl-2 pb-2 d-flex align-items-center justify-content-between">
                    <span class="xxs text-color-dusk bold cursor-pointer">
                      <ins>Varsayılan yap</ins>
                    </span>
                    <i class="xl icon-delete text-color-white-three cursor-pointer" />
                  </div>
                  <div>
                    <b-img-lazy src="http://cdn1.kariyer.net/UploadFiles/Clients/Logolar/154462_110078.jpg"
                                center
                                alt="img"
                                blank-color="#bbb"
                    />
                  </div>
                  <div class="text-center pt-4 pb-3">
                    <span class="xxs text-color-warm-grey bold">YÜKLEME TARİHİ: 21 EKİM 2017</span>
                  </div>
                </b-card>
              </b-col>
              <b-col cols="4">
                <b-card no-body>
                  <div class="height-40 pt-2 pr-2 pl-2 pb-2 d-flex align-items-center justify-content-between">
                    <span class="xxs text-color-dusk bold">
                      Onay Bekliyor
                    </span>
                    <i class="xl icon-delete text-color-white-three cursor-pointer" />
                  </div>
                  <div>
                    <b-img-lazy src="http://cdn1.kariyer.net/UploadFiles/Clients/Logolar/154462_110078.jpg"
                                center
                                alt="img"
                                blank-color="#bbb"
                    />
                  </div>
                  <div class="text-center pt-4 pb-3">
                    <span class="xxs text-color-warm-grey bold">YÜKLEME TARİHİ: 21 EKİM 2017</span>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>

<script>
export default {
  name: 'WhiteBoxCard',
  data() {
    return {
      imgConfig: {
        src: require('../../assets/imgIcons/resume-pool.svg'),
        center: true,
        alt: 'img',
        'blank-color': '#bbb',
        style: {
          width: '176px',
          height: '176px',
        },
      },
    };
  },
};
</script>
